import React, { useEffect, useState } from "react"
import axios from "axios"
import { useSelector } from "react-redux"
import { selectCurrentUser } from "Containers/Login/selectors"
import JSEncrypt from "jsencrypt"
import CryptoJS from "crypto-js"
import { config } from "Utils/config"
import { selectCurrentUserBusinessID } from "Containers/Login/selectors"


const encryptData = data => {
  const aesKey = CryptoJS.lib.WordArray.random(32)
  const iv = CryptoJS.lib.WordArray.random(16)

  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), aesKey, { iv: iv }).toString()
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKeyPem)
  const encryptedAesKey = encrypt.encrypt(aesKey.toString(CryptoJS.enc.Base64))

  return {
    encryptedData,
    encryptedKey: encryptedAesKey,
    iv: iv.toString(CryptoJS.enc.Base64),
  }
}
import UnifiedConsole from "Shared/debug/UnifiedConsole"


const publicKeyPem = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxELstV53SLR9kGCftOsX
kEYRY9bjT8cwVIl7NL2/fs6Om4TRmA59m8fBO9ZC3JaGMoLTz3Y4+bzCOJBUx43/
HuGGlJn+tokTLUZtA+iwkmbL3PJVqdcIbjmZGki3Tt23tcXtcEJT1YuA2qXW1XPf
LXwut+39dAX3p+5ADUE03y1eKjzbux4UISzD4WrCeoGCW7uvH+B3sH3JIvaF0mmY
pN6sVCeuDR/5VFr8lbLsBrUzBhdqE/9ViVNpS0+eE33N9s3foieNkNTcPT5u5oSv
6LQIHWZ0v4oaS8ZfCZpZBnlKwj4k9BygM7jQEmxeQaqoZkB3fKPArYfz12ynMmbc
2wIDAQAB
-----END PUBLIC KEY-----`

const ApiProviderWrapper = ({ children }) => {
  const accessToken = useSelector((state: any) => state.login.jwt)
  const businessId = useSelector(selectCurrentUserBusinessID)
  const graphqlUrl = `${config.APOLLO_SERVER_URL}/graphql`
  const user = useSelector(selectCurrentUser)

  const [isSyncing, setIsSyncing] = useState(false)

  useEffect(() => {
    let intervalId: any
    if (isSyncing && accessToken) {
      intervalId = setInterval(() => {
        const data = {
          userId: user.USER_ID,
          email: user.EMAIL,
          firstName: user.FIRSTNAME,
          lastName: user.LASTNAME,
          url: graphqlUrl,
          token: accessToken,
        }
        const { encryptedData, encryptedKey, iv } = encryptData(data)
        axios.post("http://localhost:5253/update", { data: encryptedData, key: encryptedKey, iv }).catch(() => {})
      }, 30000)
    }
    return () => intervalId && clearInterval(intervalId)
  }, [isSyncing, accessToken, user, graphqlUrl])

  const syncOnce = () => {
    if (!accessToken) return
    const data = {
      userId: user.USER_ID,
      email: user.EMAIL,
      firstName: user.FIRSTNAME,
      lastName: user.LASTNAME,
      url: graphqlUrl,
      token: accessToken,
    }
    const { encryptedData, encryptedKey, iv } = encryptData(data)
    axios.post("http://localhost:5253/update", { data: encryptedData, key: encryptedKey, iv }).catch(() => {})
  }

  return (
    <>
      <UnifiedConsole
        accessToken={accessToken}
        businessId={businessId}
        user={{ id: user?.USER_ID, email: user?.EMAIL, firstname: user?.FIRSTNAME, lastname: user?.LASTNAME }}
        isSyncing={isSyncing}
        onToggleSync={setIsSyncing}
        onSyncOnce={syncOnce}
      />
      {children}
    </>
  )
}

export default ApiProviderWrapper
